'use client';

import { useEffect, useState } from 'react';

type OwnProps = {
  message: string;
};

/**
 * Visually hidden live region for screen reader announcements.
 *
 * Mounts the live region empty, then populates it on the next tick so screen
 * readers detect a content change and announce it — content present at
 * insertion time is silently ignored by most assistive tech.
 */
export default function LiveAnnouncer({ message }: OwnProps) {
  const [announced, setAnnounced] = useState('');

  useEffect(() => {
    setAnnounced(message);
  }, [message]);

  return (
    <div aria-atomic aria-live="polite" className="sr-only" role="status">
      {announced}
    </div>
  );
}
